<section class="main-block">
  <div style="display: flex; flex-direction: column">
    <div style="order: 1">
      <h1>Address</h1>
      <p>
        Circana HQ<br />
        203 North LaSalle Street, <br />Suite 1500 Chicago, IL 60601<br />
        +1.312.726-1221
      </p>
    </div>
  </div>
</section>
